export const STATE_KEY_POSITION = '__peracto_block_position'
export const STATE_KEY_BACKGROUND = '__peracto_block_background'
export const STATE_KEY_BORDER = '__peracto_block_border'
export const STATE_KEY_EFFECTS = '__peracto_block_effects'
export const STATE_KEY_ANCHOR = '__peracto_anchor'

export const TYPE_PADDING = 'padding'
export const TYPE_PADDING_MOBILE = 'paddingMobile'
export const TYPE_MARGIN = 'margin'
export const TYPE_LOCKS = 'locks'

export const TYPE_BACKGROUND_COLOR = 'backgroundColor'
export const TYPE_BACKGROUND_COLOR_OPACITY = 'backgroundColorOpacity'
export const TYPE_BACKGROUND_IMAGE = 'backgroundImage'
export const TYPE_BACKGROUND_VIDEO = 'backgroundVideo'
export const TYPE_BACKGROUND_POSITION = 'backgroundPosition'
export const TYPE_BACKGROUND_SIZE = 'backgroundSize'
export const TYPE_BACKGROUND_REPEAT = 'backgroundRepeat'
export const TYPE_BACKGROUND_MODE = 'backgroundMode'
export const TYPE_BACKGROUND_LOADING_METHOD = 'backgroundLoadingMethod'
export const TYPE_BACKGROUND_ALT_TEXT = 'backgroundAltText'

export const TYPE_BORDER_X = 'borderX'
export const TYPE_BORDER_Y = 'borderY'
export const TYPE_BORDER_WIDTH = 'borderWidth'
export const TYPE_BORDER_COLOR = 'borderColor'
export const TYPE_BORDER_STYLE = 'borderStyle'

export const TYPE_ANIMATION_STYLE = 'animationStyle'
export const TYPE_ANIMATION_DELAY = 'animationDelay'
export const TYPE_ANIMATION_DURATION = 'animationDuration'
export const TYPE_ANIMATION_HOVER = 'animationHover'

export const TYPE_BOX_SHADOW = 'boxShadow'

export const TYPE_ANCHOR_ID = 'anchorId'

export const DIRECTION_VERT = 'vertical'
export const DIRECTION_HORZ = 'horizontal'

export const BACKGROUND_MODE_COLOUR_FLAG = 1
export const BACKGROUND_MODE_IMAGE_FLAG = 2
export const BACKGROUND_MODE_VIDEO_FLAG = 3
